export const BonusLoginType = [
    { label: 'NewPlayer', value: 1 },
    { label: 'RoutinePlayer', value: 2 }
];
